import { useDebouncedCallback } from "@react-hookz/web";
import { useSetAtom } from "jotai";

import { useStickyElementObserver } from "~/lib/hooks";

import { appBarStickyHeightAtom } from "./atoms";

export const useAppBarSetStickyHeight = () => {
  const setStickyHeight = useSetAtom(appBarStickyHeightAtom);
  const updateStickyHeight = useDebouncedCallback(
    (height: number) => setStickyHeight(height),
    [setStickyHeight],
    100,
  );

  const { reference } = useStickyElementObserver(
    (rect, isSticky) => {
      // For supporting the content is hidden on the top (translateY)
      const height = isSticky ? rect.height + rect.top : 0;
      updateStickyHeight(height);
    },
    { supportScrollEvent: true },
  );

  return {
    reference,
  };
};
